import { createAsyncThunk } from '@reduxjs/toolkit';
import type { OrganisationNode } from '@syfo/types/adviser.types';

interface UpdateAdviserOrganisationParams {
  uuid: string;
  organisation: OrganisationNode;
}

interface UpdateAdviserOrganisationResponse {
  message: string;
}

/**
 * Update adviser organisation information
 */
export const updateAdviserOrganisationThunk = createAsyncThunk<
  UpdateAdviserOrganisationResponse,
  UpdateAdviserOrganisationParams
>(
  'advisers/updateOrganisation',
  async ({ uuid, organisation }) => {
    console.log(`[Advisers] Updating organisation for adviser ${uuid}...`);

    const response = await fetch(`/api/advisers/${uuid}/organisation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(organisation)
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Adviser not found');
      }
      const errorText = await response.text();
      console.error(`[Advisers] Failed with status ${response.status}: ${errorText}`);
      throw new Error(`Failed to update adviser organisation: ${response.status}`);
    }

    console.log('[Advisers] Organisation updated successfully');
    
    return { message: 'Organisation updated successfully' };
  }
);
